import { useTranslation } from "next-i18next";

import de from "@/features/promotions/locales/de";
import en from "@/features/promotions/locales/en";
import es from "@/features/promotions/locales/es";
import fr from "@/features/promotions/locales/fr";
import it from "@/features/promotions/locales/it";
import nl from "@/features/promotions/locales/nl";
import { useContentLocale } from "@/i18n/hooks";

export const promotionResources = { en, nl, de, fr, es, it };
export type PromotionCopyKey = keyof typeof en;
/**
 * Versioned launch resources; existing Lokalise translations take precedence.
 * `locale` is the content language (`/en-us` reads `en`, WHO-5766): use the
 * router's locale, not this one, to build a URL.
 */
export const usePromotionCopy = () => {
  const language = useContentLocale();
  const { i18n, t } = useTranslation("promotions");

  if (i18n?.addResourceBundle) {
    i18n.addResourceBundle(
      language,
      "promotions",
      promotionResources[language],
      true,
      false
    );
  }

  return {
    locale: language,
    copy: (key: PromotionCopyKey, values?: Record<string, string | number>) =>
      t(key, {
        lng: language,
        defaultValue: promotionResources[language][key],
        ...values,
      }),
  };
};
